export const GENERIC_ERROR_MESSAGE = "An Error Occurred";
export const NETWORK_FAILURE_ERROR_MESSAGE =
  "There was a problem with the network or contacting our servers.";
export const NETWORK_FAILURE_ACTION_MESSAGE =
  "Please check your Internet connection or contact support@studio.com or our chat.";
export const NETWORK_FAILURE_ERROR_AND_ACTION_MESSAGE = `${NETWORK_FAILURE_ERROR_MESSAGE} ${NETWORK_FAILURE_ACTION_MESSAGE}`;
export const CREATE_ACCOUNT_FAILURE_MESSAGE =
  "There was a problem creating your account. Please try logging in if you already have an account.";
